import { Link } from "react-router-dom";

export function Logo({ className = "", light = false, size = "md" }) {
  const dim = size === "lg" ? "h-10 w-10" : "h-8 w-8";
  const text = size === "lg" ? "text-2xl" : "text-xl";
  return (
    <Link to="/" className={`flex items-center gap-2.5 ${className}`} data-testid="drelik-logo">
      <img src="/branding/drelik-icon.png" alt="Drelik" className={`${dim} object-contain`} />
      <span className={`font-heading font-bold tracking-tight ${text} ${light ? "text-white" : "text-foreground"}`}>
        Drelik
      </span>
    </Link>
  );
}

export function LogoIcon({ className = "h-8 w-8" }) {
  return <img src="/branding/drelik-icon.png" alt="Drelik" className={`${className} object-contain`} />;
}
